import { RequestIdentity } from '../../../../models/RequestIdentity';

/**
 * Создаёт копию request identity с новым идентификатором сущности.
 */
export function replaceRequestIdentity(
  identity: RequestIdentity,
  newId: string | null,
): RequestIdentity {
  if (!identity) {
    return identity;
  }

  return {
    ...identity,
    id: newId,
  };
}
